export const MAX_PREVIEW_IMAGES = 50;
export const UPLOAD_DIALOG_Z_INDEX = 300001;
